import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, {useState} from "react";
import {axios_tenant} from "../../../../axios";

const ExpiryLinkModal = ({ open, setOpen, displayMessage, setOpenDisplay }) => {
    const [loading,setLoading] = useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const handleContactSupport = async () => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get("email");

        try {
            setLoading(true);
            await axios_tenant.post("/utils/support", {
                email
            });
            setOpen(false);
            setOpenDisplay(true);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
    >
      <Box display="flex" justifyContent="center" mt={2}>
        <img 
          src="/images/logo.png" 
          alt="Trexo Global" 
          style={{ width: "30%", margin: 10 }}
        />
      </Box>

      <DialogTitle sx={{ textAlign: "left"}}>
        This link has expired. Don’t worry!
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ textAlign: "left", color: "#0A9150", fontSize: "1.1rem", fontWeight: 600 }}>
          {displayMessage}
        </DialogContentText>

        {!(displayMessage.includes("support")) && <DialogContentText sx={{ textAlign: "left", mt: 1 }}>
          Please check your inbox (or spam folder, if needed).
        </DialogContentText>}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "left", mb: 2 }}>
        <Button 
          variant="outlined"
          onClick={handleContactSupport}
          sx={{ 
            borderColor: "#010160",
            color: "#010160",
            textTransform: "none",
            minWidth: 150
          }}
        >
          {loading ? <CircularProgress size={20} sx={{ color: "blue" }} /> : <span>Contact Support</span>}
                    
        </Button>
        {/* <Button 
          variant="contained" 
          onClick={handleClose} 
          sx={{ backgroundColor: "#010160", textTransform: "none" }}
        >
          OK
        </Button> */}
      </DialogActions>
    </Dialog>
  );
}

export default ExpiryLinkModal;